import { Checkbox } from "@cappelendamm/design-system/react";
import { useFormContext } from "react-hook-form";

type DeliveryAsBillingCheckboxProps = {
  isDisabled: boolean;
};

export type DeliveryAsBillingForm = {
  billingAddressIsSameAsDeliveryAddress: boolean;
};

export const DeliveryAsBillingCheckbox = ({
  isDisabled,
}: DeliveryAsBillingCheckboxProps) => {
  const { register } = useFormContext<DeliveryAsBillingForm>();
  return (
    <label
      htmlFor="billingAddressIsSameAsDeliveryAddress"
      className="flex items-center gap-2 rounded-md bg-gray-100 p-2 hover:cursor-pointer"
    >
      <Checkbox
        disabled={isDisabled}
        id="billingAddressIsSameAsDeliveryAddress"
        {...register("billingAddressIsSameAsDeliveryAddress")}
      />
      Ja, fakturaadresse er lik som den over
    </label>
  );
};
